import foreign from './foreign.js'
import course from './course.js'
import regulatory from './regulatory.js'
import foreignprogress from './foreignprogress.js'
import staffmanagement from './staffmanagement.js'
import rulesetting from './rulesetting.js'
import foreigninst from './froeigninst.js'
import foreigschedule from './foreignschedule'
import foreignrecords from './foreigncourserecords'
const routes = [
  ...foreign,//外教管理
  ...course,//外教课程管理
  ...regulatory,//外教监课管理
  ...foreignprogress,//外教授课进度
  ...staffmanagement,//外教员工管理
  ...rulesetting,//外教规则设置
  ...foreigninst,//外教机构管理
  ...foreignrecords,//外教的约课记录
  ...foreigschedule
]
export default routes;
